import React, { useState } from 'react'
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap'

const SimpleDropdown = (props) => {

    const [dropdownOpen, setDropdownOpen] = useState(false);

    const toggle = () => setDropdownOpen(prevState => !prevState);

    const options = props.values.map((label, index) => {
        const href = props.hrefs ? props.hrefs[index] : undefined
        return (
            <DropdownItem
                key={'key' + index}
                tag={href ? 'a' : undefined}
                href={href}
                onClick={(e) => {
                    if (href && (e.ctrlKey || e.metaKey || e.shiftKey)) return
                    if (href) e.preventDefault()
                    props.onChange(index)
                }}
            >{label}</DropdownItem>
        )
    })


    const size = props.size ? props.size : "md"

    return (
        <Dropdown
            style={props.style}
            isOpen={dropdownOpen} toggle={toggle}>
          <DropdownToggle caret size={size}>
            {props.values[props.index]}
          </DropdownToggle>
          <DropdownMenu container="body">
            {options}
          </DropdownMenu>
        </Dropdown>
    )
}

export default SimpleDropdown
